export default {
  'manufacturers.general.form.description': 'Manufacturer Description',
  'manufacturers.general.form.deleteButton': 'Remove',
  'manufacturers.general.form.okButton': 'Save',
  'manufacturers.modal.create.title': 'Add manufacturer',
  'manufacturers.modal.create.messageSuccess': 'Updated successfully!',
  'manufacturers.modal.edit.title': 'Edit manufacturer',
  'manufacturers.modal.edit.messageSuccess': 'Registered successfully!',
  'manufacturers.modal.messageError': 'Unable to save action!',
  'manufacturers.page.title': 'Manufacure',
  'manufacturers.page.button.generateReport': 'Generate Report',
  'manufacturers.page.button.newManufacturer': 'New Manufacturer',
  'manufacturers.list.header.description': 'Manufacturer Description',
  'manufacturers.list.header.manufacturerCode': 'Manufacturer Code',
  'manufacturers.list.header.added': 'Added',
  'manufacturers.list.header.action': 'Action',

  'manufacturers.modal.status.disable.title': 'Disable manufacturer',
  'manufacturers.modal.status.disable.description':
    'Do you want to disable the manufacturer',
  'manufacturers.modal.status.enable.title': 'Enable manufacturer',
  'manufacturers.modal.status.enable.description':
    'Do you want to enable the manufacturer',

  'manufacturers.modal.report.form.description': 'Description',
  'manufacturers.modal.report.title': 'Generate Report',
  'manufacturers.modal.report.buttons.viewReport': 'View Report',
  'manufacturers.modal.report.buttons.pdf': 'Generate PDF',
  'manufacturers.modal.report.buttons.rtf': 'Generate RTF',
  'manufacturers.modal.report.buttons.csv': 'Generate CSV',
  'manufacturers.notification.generate.report.title':
    'Report Generated Successfully',
  'manufacturers.notification.generate.report.description':
    'Successfully Generated Manufacturers Report!',
};
